import produce from 'immer'
import { actionTypes } from '../actions/foodActions'
const initialState = {}

const FoodReducer = (state = initialState, action) =>
    produce(state, draft => {
        switch (action.type) {
            case actionTypes.SET_LIST_FOOD: {
                return action.payload
            }
            default:
                return state
        }
    })

export default FoodReducer
